import React from 'react';

const InterviewAnalyst = () => {
  return (
    <div className="p-4 border rounded-lg shadow-sm bg-white dark:bg-gray-800">
      <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Interview Analyst</h2>
      <p className="text-gray-600 dark:text-gray-300">
        Feed the AI a transcript of an interview to generate a "Follow-Up Questions" brief. It will identify ambiguous statements and potential evasiveness.
      </p>
      <div className="mt-4">
        <textarea
          className="w-full p-2 border rounded-md bg-gray-50 dark:bg-gray-700 dark:text-gray-200"
          rows="5"
          placeholder="Paste interview transcript here..."
        ></textarea>
        <button className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
          Analyze
        </button>
      </div>
    </div>
  );
};

export default InterviewAnalyst;